import type { HTMLAttributes } from 'react'
import type { InterfaceSound } from '@v2/table'

const selector = 'button, a[href], summary, select, input[type="radio"], input[type="checkbox"], [role="button"]'
function control(target: EventTarget | null): HTMLElement | null {
  const element = target instanceof Element ? target.closest<HTMLElement>(selector) : null
  return element && !element.matches(':disabled, [aria-disabled="true"], [data-ui-sound="none"]') ? element : null
}

/** Delegated to one surface, so nested icons/text never cause duplicate sounds. */
export function interfaceSoundEvents(play: (sound: InterfaceSound) => void): HTMLAttributes<HTMLElement> {
  return {
    onPointerOver: event => {
      if (event.pointerType === 'touch') return
      const target = control(event.target)
      if (target && target !== control(event.relatedTarget)) play('hover')
    },
    onFocus: event => {
      const target = control(event.target)
      if (target?.matches(':focus-visible')) play('hover')
    },
    onClickCapture: event => {
      const target = control(event.target)
      if (!target) return
      const sound = target.dataset.uiSound
      play(sound === 'cancel' || sound === 'confirm' || sound === 'error' ? sound : 'select')
    },
  }
}
